import React from 'react';

import Form from '../../../../../../../../components/Form/Form/';
import MultiVariableInput from '../../../../../../../../components/Form/MultiVariableInput/';
import UniversitySelector from '../UniversitySelector/';
import DegreeTypeSelector from '../DegreeTypeSelector/';
import MajorSelector from '../MajorSelector/';
import Spinner from '../../../../../../../../components/Spinner/';

import './Education.scss';

class Education extends React.Component {
  constructor(props, context) {
    super(props, context);

    // Initial sort of user degrees
    let education = typeof props.EducationUserData.viewer !== 'undefined' ? props.EducationUserData.viewer.degrees.slice(0) : [];

    Bugsnag.leaveBreadcrumb('Advisor loaded Education with the following Data: ' + JSON.stringify(education, null, 2));

    education.sort((a, b) => {
      return a.graduation_date === b.graduation_date ? 0 : (a.graduation_date > b.graduation_date ? 1 : 0);
    });

    let initialValues = {
      Education: this.formatInitialValues(education)
    };

    Bugsnag.leaveBreadcrumb('Data parsed into: ' + JSON.stringify(initialValues, null, 2));

    this.state = {
      changeMade: false,
      saving: false,
      customButtonMessage: null,
      errorFound: null,
      initialValues: initialValues,
      currentValues: initialValues,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEducationRemove = this.handleEducationRemove.bind(this);
    this.getButtonText = this.getButtonText.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }

  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  };

  routerWillLeave(nextLocation) {
    if (this.state.changeMade) {
      return 'Your work is not saved! Are you sure you want to leave?';
    }
  };

  formatInitialValues(data) {
    return data.map(iteration => {
      let Data = {
        Id: iteration.graduation_id,
        DegreeID: iteration.id,
        University: iteration.university,
        Major: iteration.major,
      };

      if (iteration.graduation_date !== null && typeof iteration.graduation_date !== 'undefined') {
        Data['Month'] = iteration.graduation_date.split('-')[1];
        Data['Year'] = iteration.graduation_date.split('-')[0];
      }

      if (iteration.degree_type !== null) {
        if (Object.prototype.hasOwnProperty.call(iteration.degree_type, 'id')) {
          Data['DegreeType'] = iteration.degree_type.id;
        }
      }

      return Data;
    });
  }

  handleChange(event) {
    window.onbeforeunload = function () {
      return true;
    };

    this.setState({
      changeMade: true,
      currentValues: event.target.value,
      customButtonMessage: null,
      errorFound: null,
    });
  }

  handleEducationRemove(EducationEntry) {
    // TODO Remove Function
  }

  handleSave() {
    this.setState({
      saving: true
    });

    window.onbeforeunload = null;

    Bugsnag.leaveBreadcrumb('Attempting to Save Education');

    let Majors = []; // Array containing names of new Majors or null
    let Errors = false;

    const FilteredEnrties = this.state.currentValues.Education.filter(x => x !== null && typeof x !== 'undefined');
    console.log(FilteredEnrties);

    let upsertGraduationInfo = FilteredEnrties.map(EducationData => {
      if (Object.prototype.hasOwnProperty.call(EducationData, 'University') && EducationData !== null && EducationData !== undefined && Object.prototype.hasOwnProperty.call(EducationData, 'Major')) {
        if (EducationData.Major.id === null) {
          Majors.push(EducationData.Major.name);
        } else {
          Majors.push(null);
        }

        if (EducationData.University.id === 99999) {
          this.setState({
            saving: false,
            changeMade: false,
            customColor: 'red',
            errorFound: true,
            customButtonMessage: 'Please Select from drop down',
          });
          return null;
        };
        return {
          Id: EducationData.Id,
          UserID: this.props.EducationUserData.variables.UserID,
          MajorID: EducationData.Major.id,
          UniID: EducationData.University.id,
          DegreeTypeID: EducationData.DegreeType,
          GraduationDate: EducationData.Year + '-' + EducationData.Month + '-01 12:00:00',
        };
      }

      console.log('failed:  ', EducationData);
      return null;
    }).filter(x => {
      if (x !== null) {
        return true;
      }

      Errors = true;
      return false;
    });

    Bugsnag.leaveBreadcrumb('Attempting to create Majors: ' + JSON.stringify(Majors, null, 2));

    if (Errors === false) {
      Promise.all(Majors.map(major => {
        if (major !== null) {
          return this.props.UpsertMajor({
            variables: {
              Name: major
            }
          });
        }
        return Promise.resolve(null);
      })).then(finalisedMajors => {
        Bugsnag.leaveBreadcrumb('Majors saved Succesfully: ' + JSON.stringify(finalisedMajors, null, 2));
        finalisedMajors.forEach((finalMajor, index) => {
          if (finalMajor !== null) {
            upsertGraduationInfo[index].MajorID = finalMajor.data.createMajor.id;
          }
        });

        Bugsnag.leaveBreadcrumb('Attempting to upsert Graduation info: ' + JSON.stringify(upsertGraduationInfo, null, 2));

        return this.props.SetUserGraduations({
          variables: {
            Graduations: upsertGraduationInfo.map(Entry => ({
              major_id: Entry.MajorID,
              university_id: Entry.UniID,
              degree_type_id: Entry.DegreeTypeID,
              graduation_date: Entry.GraduationDate,
            }))
          }
        });
      }).then(data => {
        Bugsnag.leaveBreadcrumb('Saved Successfully: ' + JSON.stringify(data, null, 2));

        this.setState({
          saving: false,
          changeMade: false,
          customButtonMessage: 'Saved Successfully',
          customColor: null,
          initialValues: {
            Education: this.state.currentValues.Education
          }
        });
      }).catch(error => {
        Bugsnag.notifyException(error);
        console.log(error);
        this.setState({
          saving: false,
          changeMade: true,
          errorFound: true,
        });
      });
    } else {
      console.log('Missing Fields');
      this.setState({
        saving: false,
        changeMade: false,
        customColor: 'red',
        errorFound: true,
        customButtonMessage: 'Missing required fields',
      });
    }
  }

  getButtonText() {
    if (this.state.customButtonMessage !== null) {
      return this.state.customButtonMessage;
    }

    if (this.state.saving) {
      return <Spinner className='spinner--white' />;
    }

    if (this.state.changeMade === false) {
      return 'No Changes made';
    }

    return 'Save';
  }

  render() {
    return (
      <div>
        <div className='ProfileEducation'>
          <h1>Profile Education</h1>
          <Form defaultValue={this.state.initialValues} onChange={this.handleChange}>
            <MultiVariableInput removeButton={props => {
              return (<a className='ProfileEducation__RemoveButton' onClick={props.onClick}><b>×</b> Remove</a>);
            }} onRemove={this.handleEducationRemove} name='Education' className='Education'
              ButtonText='+ Add Education Degree'>
              <input type='hidden' name='Id' />
              <div className='row'>
                <div className='col-md'>
                  <div className='Form__inputWrap'>
                    <label className='Form__InputLabel'>School*<span>(select from list)</span></label>
                    <UniversitySelector name='University' className='Form__Input Form__Input--white' />
                  </div>
                </div>
                <div className='col-md'>
                  <div className='Form__inputWrap'>
                    <label className='Form__InputLabel'>Degree Type*</label>
                    <DegreeTypeSelector DegreeTypes={this.props.EducationUserData.getDegreeTypes} name='DegreeType' className='Form__Input Form__Input--white' />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md'>
                  <div className='Form__inputWrap'>
                    <label className='Form__InputLabel'>Degree Major*<span>(select or create your own)</span></label>
                    <MajorSelector name='Major' className='Form__Input Form__Input--white' />
                  </div>
                </div>
                <div className='col-md'>
                  <div className='Form__inputWrap'>
                    <label className='Form__InputLabel'>Graduation Date</label>
                    <div className='row'>
                      <div className='col'>
                        <select className='Form__Input Form__Input--white' name='Year' required>
                          <option>Year</option>
                          <option value='2017'>2017</option>
                          <option value='2016'>2016</option>
                          <option value='2015'>2015</option>
                          <option value='2014'>2014</option>
                          <option value='2013'>2013</option>
                          <option value='2012'>2012</option>
                          <option value='2011'>2011</option>
                          <option value='2010'>2010</option>
                          <option value='2009'>2009</option>
                          <option value='2008'>2008</option>
                          <option value='2007'>2007</option>
                          <option value='2006'>2006</option>
                          <option value='2005'>2005</option>
                          <option value='2004'>2004</option>
                          <option value='2003'>2003</option>
                          <option value='2002'>2002</option>
                          <option value='2001'>2001</option>
                          <option value='2000'>2000</option>
                        </select>
                      </div>
                      <div className='col'>
                        <select className='Form__Input Form__Input--white' name='Month' required>
                          <option>Month</option>
                          <option value='01'>Jan</option>
                          <option value='02'>Feb</option>
                          <option value='03'>Mar</option>
                          <option value='04'>Apr</option>
                          <option value='05'>May</option>
                          <option value='06'>Jun</option>
                          <option value='07'>Jul</option>
                          <option value='08'>Aug</option>
                          <option value='09'>Sep</option>
                          <option value='10'>Oct</option>
                          <option value='11'>Nov</option>
                          <option value='12'>Dec</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </MultiVariableInput>
          </Form>
        </div>
        <button disabled={this.state.changeMade === false && this.state.saving === false} onClick={this.handleSave}
          style={(this.state.errorFound === null) ? {} : { background: '#e85959' }} className='SaveEducation__button'>
          {this.getButtonText()}
        </button>
      </div>
    );
  }
};

export default Education;



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Education/components/Education/index.js